import ApiService from './api.service'

const TeamService = {
  createAndAddNewPlayerToTeam (teamUuid, data) {
    return ApiService.postWithoutLoading(`api/v1/game/teams/${teamUuid}/createAndAddNewPlayerToTeam`, data)
  },
  addPlayerToTeam (teamUuid, data) {
    return ApiService.postWithoutLoading(`api/v1/game/teams/${teamUuid}/addPlayerToTeam`, data)
  },
  editPlayer (teamUuid, playerUuid, data) {
    return ApiService.putWithoutLoading(`api/v1/game/teams/${teamUuid}/editPlayer/${playerUuid}`, data)
  }
}

export default TeamService
